import ReactDOM from "react-dom";
import React from "react";
import { Storage } from './../Core/Storage';
import { Routes } from './../Core/Constants';
import { AppStore } from './../Core/AppStore';
import { UserProvider } from './../Providers/UserProvider';
import { forEach } from "../../../Content/scripts/app/src/components/stores";

export default class LoginHeader extends React.Component {
	constructor(props) {
		super(props);

	}
	componentDidMount = () => {
		var that = this;
		AppStore.on('User.ChangeLogin', function () {
			that.forceUpdate();
		});
	}

	handleLogout = (e) => {
		e.preventDefault();
		UserProvider.signOut();
	}

	render = () => {
		let T = window.Texts.loginHeader;
		return (
			<>
				{(Storage.instance().isAuthorized()) ?
					<>
						<li className="my-account-li d-none d-md-block">
					

							<a href={Routes.EditUser} class="" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">{T.myAccount + ' (' + Storage.instance().userName+')'}</a>
						<div className="dropdown-menu">
							<ul>
								<li><a href={Routes.Orders}><u>{T.loginCustomer_Orders}</u></a></li>
								<li><a href={Routes.EditUser}><u>{T.loginCustomer_Edit}</u></a></li>
								<li><a href={Routes.ChangePassword}>{T.loginCustomer_ChangePassword}</a></li>
								<li><a href="#" onClick={(e) => this.handleLogout(e)}><u>{T.loginCustomer_Logout}</u></a></li>
							</ul>
						</div>
						</li>
						<li className="d-inline-block d-md-none ">
							<a href={Routes.EditUser} role="button" className="d-block d-md-none">{T.myAccount}</a>
						</li>
						<li className="d-inline-block d-md-none ">
							<a href={Routes.ChangePassword} role="button" class="">{T.loginCustomer_ChangePassword}</a>
						</li>
						<li className="d-inline-block d-md-none ">
							<a href="#" onClick={(e) => this.handleLogout(e)} role="button" class="">{T.loginCustomer_Logout}</a>
						</li>

						</>:
					<>
						<li><a href={Routes.Login}><u>{T.login}</u></a></li>
						<li><a href={Routes.Register}><u>{T.registration}</u></a></li>
					</>
				}
			</>
		);
	}
}

//inicializace
var elements = document.querySelectorAll("[data-role='app-login-header']");
if (elements.length > 0) {
	elements.forEach((element) => {
		ReactDOM.render(<LoginHeader />, element);
	})
}
